import { render, staticRenderFns } from "./fccMensagensTipo.vue?vue&type=template&id=1ff363d6"
import script from "./fccMensagensTipo.vue?vue&type=script&lang=js"
export * from "./fccMensagensTipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports